/* eslint-disable @typescript-eslint/default-param-last */
import { IZoomClientType } from "@/types/zoomClient.types";
import {
  CREATE_ZOOM_CLIENT,
  END_INTERVIEW_FOR_ALL,
  LEAVE_INTERVIEW,
  MOVE_CANDIDATE_TO_LOBBY,
  REMOVE_ZOOM_CLIENT,
  SAVE_ZOOM_STREAM,
} from "@/constants/ActionTypes";
import initialState from "@/store/initialState";

const zoomClientReducer = (
  state = initialState.zoomClient,
  action: IZoomClientType,
) => {
  switch (action.type) {
    case `${CREATE_ZOOM_CLIENT}_SUCCESS`:
      return {
        ...state,
        client: action.payload.client,
      };
    case `${SAVE_ZOOM_STREAM}_SUCCESS`:
      return {
        ...state,
        stream: action.payload.stream,
      };
    case `${REMOVE_ZOOM_CLIENT}_SUCCESS`:
    case `${LEAVE_INTERVIEW}_SUCCESS`:
    case `${MOVE_CANDIDATE_TO_LOBBY}_SUCCESS`:
    case `${END_INTERVIEW_FOR_ALL}_SUCCESS`:
      return initialState.zoomClient;
    default:
      return state;
  }
};

export default zoomClientReducer;
